import React, {Component} from "react";
import {Link} from "react-router-dom";

class HeaderRight extends Component {
    logoutUser(){
        localStorage.setItem('is_user_login',false);
    }
    render() {
        return (
            <>
                <ul className="header-right">
                    <li>
                        <Link to={'/chat'}>
                            <i className="fa fa-comments" />
                            {/* <span className="badge">6</span>*/}
                        </Link>
                    </li>
                    <li>
                        <Link to={'#'}>
                            <i className="fa fa-bell animated infinite swing" />
                             {/* <span className="badge">6</span> */}
                        </Link>
                    </li>
                    
                    <li className="hidden">
                        <Link to={'/pin-verification'} id="header-logout" onClick={()=>{this.logoutUser()}}>logout</Link>
                    </li>
                </ul>
            </>
        );
    }
}

export default HeaderRight;